import React, { useCallback, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import FeedbackDialog from "./FeedbackDialog";
import { FEEDBACK_EVENT } from "./feedbackBus";
import { captureViewport } from "./screenshot";

// Mounted once in the app shell: the Help & feedback dialog and the listener for openFeedback()
// calls — from the "?" icon in the top bar (NavbarComponents/RightToolbar.jsx), the sidebar's
// Help entry and the "Report this problem" links. The screenshot is captured in the
// background while the dialog opens; the dialog itself is excluded from it.
const FeedbackLauncher = () => {
  const isAuthenticated = useSelector((state) => Boolean(state.auth?.isAuthenticated));
  const [open, setOpen] = useState(false);
  const [prefill, setPrefill] = useState(null);
  const [shot, setShot] = useState(null);
  const [shotError, setShotError] = useState("");
  const [shotBusy, setShotBusy] = useState(false);
  const captureSeq = useRef(0);

  // The dialog opens at once (it is excluded from the capture by data-no-screenshot) and the
  // screenshot arrives when ready; a slow page must not make the button feel dead.
  const launch = useCallback(async (detail = null) => {
    const seq = ++captureSeq.current;
    setPrefill(detail && typeof detail === "object" ? detail : null);
    setShot(null);
    setShotError("");
    setShotBusy(true);
    setOpen(true);
    try {
      const dataUrl = await captureViewport();
      if (seq === captureSeq.current) setShot(dataUrl);
    } catch {
      if (seq === captureSeq.current) {
        setShotError("The automatic screenshot did not work on this page. You can capture your screen instead, or attach an image.");
      }
    } finally {
      if (seq === captureSeq.current) setShotBusy(false);
    }
  }, []);

  useEffect(() => {
    const onEvent = (event) => launch(event?.detail || null);
    window.addEventListener(FEEDBACK_EVENT, onEvent);
    return () => window.removeEventListener(FEEDBACK_EVENT, onEvent);
  }, [launch]);

  if (!isAuthenticated) return null;
  return <FeedbackDialog open={open} onClose={() => setOpen(false)} prefill={prefill} screenshotDataUrl={shot} shotError={shotError} shotPending={shotBusy} />;
};

export default FeedbackLauncher;
